let syncRaf = 0;
let listenersBound = false;
let state = null;

const mobileMediaQuery = window.matchMedia('(max-width: 899px)');

function isLayoutVisible(layout) {
  if (!(layout instanceof Element)) {
    return false;
  }

  return layout.getClientRects().length > 0 && getComputedStyle(layout).display !== 'none';
}

function isControllerEligible() {
  return mobileMediaQuery.matches && isLayoutVisible(document.querySelector('.layout-mobile'));
}

function getAnnouncementBar() {
  const layout = document.querySelector('.layout-mobile');

  if (!isLayoutVisible(layout)) {
    return null;
  }

  const bar = layout.querySelector('.video__announcement-bar');

  if (!(bar instanceof Element)) {
    return null;
  }

  return bar;
}

function measureBaseTop(section, bar) {
  const sectionRect = section.getBoundingClientRect();
  const barRect = bar.getBoundingClientRect();

  return sectionRect.top + window.scrollY + sectionRect.height - barRect.height;
}

function clearPinnedState() {
  if (!state) {
    return;
  }

  state.bar.classList.remove('video__announcement-bar--pinned');
  state = null;
}

function applyPinnedState(shouldPin) {
  if (!state) {
    return;
  }

  state.bar.classList.toggle('video__announcement-bar--pinned', shouldPin);
  state.isPinned = shouldPin;
}

function syncNow() {
  if (!isControllerEligible()) {
    clearPinnedState();
    return;
  }

  const bar = getAnnouncementBar();

  if (!bar) {
    clearPinnedState();
    return;
  }

  const section = bar.closest('.video');

  if (!(section instanceof Element)) {
    clearPinnedState();
    return;
  }

  if (!state || state.bar !== bar) {
    state = {
      bar,
      section,
      baseTop: 0,
      isPinned: false,
    };
  }

  state.baseTop = measureBaseTop(section, bar);
  applyPinnedState(window.scrollY >= state.baseTop);
}

function scheduleSync() {
  if (syncRaf) {
    return;
  }

  syncRaf = window.requestAnimationFrame(() => {
    syncRaf = 0;
    syncNow();
  });
}

function onScroll() {
  scheduleSync();
}

function onOrientationChange() {
  scheduleSync();
}

export function initVideoAnnouncementBarPin() {
  if (listenersBound) {
    syncNow();
    return;
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('orientationchange', onOrientationChange);
  listenersBound = true;
  syncNow();
}

export function syncVideoAnnouncementBarPin() {
  syncNow();
}
